import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { GQLShopFieldsContentsContactLayout } from '../generated/graphql'

const Outer = styled.div`
  margin-top: 1.875rem;
  padding: 2rem 1.5rem;
  display: flex;
  gap: 3.375rem;
  justify-content: center;
  border-top: 1px dashed var(--blue);
  border-bottom: 1px dashed var(--blue);
  align-items: center;

  @media (max-width: 40rem){
    
  border: 1px dashed var(--blue);
  padding: 1.5rem;
  flex-direction: column;
  gap: 0;
  }
`

const Head = styled.div`
  font-size: 1.125rem;
line-height: 1.5;
letter-spacing: 0.02em;
font-weight: 700;
color: var(--blue);
@media (max-width: 40rem){
  line-height: 0.84375;
letter-spacing: 0.02em;
}
`

const Value = styled.div`
font-size: 0.9375rem;
line-height: 1.6;
@media (max-width: 40rem){
  text-align: center;
  font-size: 0.875rem;
line-height: 1.5714285714285714;
margin-top: 1.0625rem;
}
`

type ShopContactProps = {
  data: DeepPartial<GQLShopFieldsContentsContactLayout>
}
export const ShopContact: FunctionComponent<ShopContactProps> = ({data}) => {
  return <Outer>
    <Head>ご予約・お問い合わせ</Head>
    <Value dangerouslySetInnerHTML={{__html: data.text ?? ''}} />
  </Outer>
}